<div class="alert alert-info inactivity-message" role="alert" *ngIf="sessionExpired">
  You have been logged out due to inactivity.
</div>


<!--  "You are using the Staging Server of the MyCare application. For the production server please go to: www.mycarereport.com."-->

<div class="login">

  <div class="nk-main">

    <div class="nk-wrap nk-wrap-nosidebar" >
      <div class="nk-content ">
          <div class="example-alert csc-alert-login" *ngIf="dev">
            <div class="alert alert-info alert-icon alert-dismissible">
              <em class="icon ni ni-alert-circle"></em> You are using the Staging Server of the MyCare application. For the production server please go to: <a href="http://www.mycarereport.com">www.mycarereport.com</a>.
            </div>

        </div>

        <div class="nk-split nk-split-page nk-split-md">
          <div class="nk-split-content nk-block-area nk-block-area-column nk-auth-container bg-white">
            <div class="nk-block nk-block-middle nk-auth-body">

              <div class="pb-2">
                <img class="logo-img logo-img-lg" [src]="logo" alt="logo">
              </div>
              <div class="nk-block-head">
                <div class="nk-block-head-content">
                  <h5 class="nk-block-title">Sign-In</h5>
                </div>
              </div><!-- .nk-block-head -->

              <form class="row" role="form" #loginForm="ngForm" (ngSubmit)="login()">

                  <div class="form-group">
                    <div class="form-label-group">
                      <label class="form-label" for="username">Email or Username</label>
                      <a class="link link-primary link-sm" tabindex="-1" href="#" hidden>Need Help?</a>
                    </div>
                    <div class="form-control-wrap">
                      <input type="text" class="form-control form-control-lg" required id="username" name="username" placeholder="Enter your email address or username" [(ngModel)]="loginData.username">
                    </div>
                  </div><!-- .form-group -->

                <div class="form-group">
                  <div class="form-label-group">
                    <label class="form-label" for="password">Passcode</label>
                    <a class="forgot-password" [routerLink]="['/forgotPassword']" tabindex="-1">Forgot Password?</a>
                  </div>
                  <div class="form-control-wrap">
                    <a tabindex="-1" href="#" class="form-icon form-icon-right passcode-switch lg" data-target="password">
                      <em class="passcode-icon icon-show icon ni ni-eye"></em>
                      <em class="passcode-icon icon-hide icon ni ni-eye-off"></em>
                    </a>
                    <input [(ngModel)]="loginData.password" type="password" required class="form-control form-control-lg" id="password" name="password" placeholder="Enter your passcode">
                  </div>
                </div><!-- .form-group -->

                  <div class="form-group remember-section">
                    <input type="checkbox" color="primary" class="remember-me nk-block-des" [checked]="rememberMe" (change)="rememberMe = !rememberMe">
                      Remember Me
                  </div>
                  <button type="submit" class="btn btn-csc-primary btn-block" [disabled]="isLoading">
                    Login
                    <i class="fa fa-spinner" aria-hidden="true" [hidden]="!isLoading"></i>
                  </button>
                  <div class="form-group nk-block-des text-center mt-3 ">
                    <a class="csc-default-href" [routerLink]="['/continueWithSSO']">Continue with SSO</a>
                  </div>

                  <div *ngIf="errorOnLogin" class="alert alert-danger d-flex align-items-center justify-content-between">
                    <div [innerHTML]="messageError | safeHtml"></div>
                    <button type="button" class="btn-close" aria-label="Close" (click)="errorOnLogin = false"></button>
                  </div>

                  <div *ngIf="errorSSOCookie" class="alert alert-danger d-flex align-items-center justify-content-between">
                    <div [innerHTML]="errorSSOCookieMessage | safeHtml"></div>
                    <button type="button" class="btn-close" aria-label="Close" (click)="errorSSOCookie = false"></button>
                  </div>

                  <!--<div [hidden]="!errorSSOCookie" class="alert alert-danger alert-dismissible fade show" [innerHTML]="errorSSOCookieMessage | safeHtml"></div>-->

              </form>

            </div>
            <div class="nk-block nk-auth-footer">
              <div class="mt-3">
                <span class="copyright" >{{'© '+year+' Cancer Support Community.' | translate}}</span>
              </div>
            </div>

          </div>
          <div class="nk-split-content nk-split-stretch">
          <!-- carousel -->
            <div id="carouselExFade" class="carousel slide carousel-fade" data-ride="carousel">
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <img id="image1" class="d-block w-100 rounded" alt="carousel1" [src]="image1">
                </div>
                <div class="carousel-item">
                  <img id="image2" class="d-block w-100 rounded" alt="carousel2" [src]="image2">
                </div>
                <div class="carousel-item">
                  <img id="image3" class="d-block w-100 rounded" alt="carousel3" [src]="image3">
                </div>
                <div class="carousel-item">
                  <img id="image4" class="d-block w-100 rounded" alt="carousel4" [src]="image4">
                </div>
                <div class="carousel-item">
                  <img id="image5" class="d-block w-100 rounded" alt="carousel5" [src]="image5">
                </div>
              </div>
<!--              <a class="carousel-control-prev" href="#carouselExFade" role="button" data-bs-slide="prev">-->
<!--                <span class="carousel-control-prev-icon" aria-hidden="true"></span>-->
<!--                <span class="visually-hidden">Previous</span>-->
<!--              </a>-->
<!--              <a class="carousel-control-next" href="#carouselExFade" role="button" data-bs-slide="next">-->
<!--                <span class="carousel-control-next-icon" aria-hidden="true"></span>-->
<!--                <span class="visually-hidden">Next</span>-->
<!--              </a>-->
            </div>
          <!-- carousel end -->
          </div><!-- .nk-split-content -->
        </div>
      </div>
    </div>
  </div>
</div>

